import React, {useState, useEffect} from "react";
import {Leaflet} from "Components/LeafletMap";
import {RoundInputWrapper} from "BaseComponents/Form";
import {FlexContainer} from "BaseComponents/Flex";
import {Paragraph, H2} from "BaseComponents/Text";
import {Dropdown} from "./Dropdown";
import {GetTextColor} from "Helpers/ColorHelper";
import {getClosestMarkers, getTwoLetterIsoArray} from "Helpers/MapHelper";
import {get} from "Helpers/ApiHelper";
import {MapBlockSelect} from "./MapBlockSelect";

export const MapBlock = ({
                           MapHits,
                           Countries,
                           BackgroundColor,
                           Heading,
                           DirectionsLinkText,
                           NoHits,
                           SearchFieldText,
                           FindUnitText,
                           OverlayImage,
                           ActivateMapText,
                           YouAreHereText,
                           PreschoolTypes,
                           TypeText,
                           TypeHeading,
                           ShowPreschoolTypes,
                           SearchHintUnit,
                           SearchTextUnit,
                           ShowUnitTypes,
                           OverlayDisabled,
                           searchCallback,
                           isMapVisible = false,
                         }) => {
  
  const [input, setInput] = useState("");
  const [unitInput, setUnitInput] = useState("");
  const [mapMarkers, setMapMarkers] = useState(MapHits);
  const [results, setResults] = useState([]);
  const [types, setTypes] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedType, setSelectedType] = useState([]);
  const [nearestMarkers, setNearestMarkers] = useState([]);
  const [isVisible, setIsVisible] = useState(isMapVisible || OverlayDisabled);
  const [selectedValue, setSelectedValue] = useState("");
  const handleInput = (inputVal) => {
    setInput(inputVal);
  };

  const handleUnitInput = (input) => {
    setUnitInput(input);
  };

  const handleTypeInput = (inputType) => {
    setSelectedType(inputType);
  };
  const endpoint = "https://nominatim.openstreetmap.org/search.php?";

  const {textColor} = GetTextColor(BackgroundColor);
  const handleChange = (item) => {
    if (item != undefined) {
      let closestMarkers = getClosestMarkers(
        item.value.lat,
        item.value.lng,
        MapHits
      );
      setSelectedValue(item.value);
      setNearestMarkers(closestMarkers);
      setMapMarkers(closestMarkers);
    } else {
      setSelectedValue("");
      setSelectedType([]);
      setSelectedUnit([]);
      setNearestMarkers([]);
      setMapMarkers(MapHits);
    }
  };

  const constructUnits = () => {
    let newUnitsList = [];
    mapMarkers.map(({Name}, i) => {
      newUnitsList.push({
        value: Name,
        label: Name,
      });
    });
    setUnits(newUnitsList);
  };

  const handleUnitChange = (selected) => {
    let tmp;
    if (selected !== null) {
      tmp = MapHits.filter((unit) => unit.Name === selected.value);

      let closestMarkers = getClosestMarkers(
        tmp[0]?.Position?.Latitude,
        tmp[0]?.Position?.Longitude,
        MapHits
      );

      setSelectedUnit(selected.value);
      setNearestMarkers(closestMarkers);
      setMapMarkers(tmp);
    } else {
      if (selectedValue && nearestMarkers) {
        setMapMarkers(nearestMarkers);
        setNearestMarkers(nearestMarkers);
      } else {
        setMapMarkers(MapHits);
        setNearestMarkers([]);
      }
    }
  };
  const handleTypeChange = (type) => {
    if (type !== null && type.length > 0) {
      let filteredMapHits = [];
      if (
        (selectedValue !== undefined || selectedValue !== null) &&
        selectedValue.length !== 0
      ) {
        filteredMapHits = nearestMarkers.filter((mapHit) => {
          {
            return (
              mapHit.PreschoolType?.length &&
              mapHit.PreschoolType.some((p) =>
                type.map((t) => t.value).includes(p)
              )
            );
          }
        });
      } else {
        filteredMapHits = MapHits.filter(
          (mapHit) =>
            mapHit.PreschoolType?.length &&
            mapHit.PreschoolType.some((p) =>
              type.map((t) => t.value).includes(p)
            )
        );
      }
      setMapMarkers(filteredMapHits);
      //setNearestMarkers(filteredMapHits);
      setSelectedType(type);
    } else {
      if (
        (selectedValue !== undefined ||
          selectedValue !== null ||
          selectedValue.length > 0) &&
        nearestMarkers
      ) {
        //setMapMarkers(nearestMarkers);
        if (type !== null) {
          setSelectedType(type);
          setMapMarkers(nearestMarkers);
        } else {
          setSelectedType({});
          setMapMarkers(MapHits);
        }
      } else {
        setNearestMarkers([]);
        setSelectedValue("");
        setSelectedType({});
        setMapMarkers(MapHits);
      }
    }
  };

  const constructTypes = () => {
    let typesList = [];
    PreschoolTypes &&
    mapMarkers.map(({PreschoolType}, i) => {
      PreschoolType?.length > 0 &&
      PreschoolType.map((p) => {
        !typesList.includes(p) && typesList.push({value: p, label: p});
      });
    });

    const uniqueTypes = typesList.filter(
      (el, i) => i === typesList.findIndex((elem) => elem.value === el.value)
    );
    setTypes(uniqueTypes);
  };

  useEffect(() => {
    constructTypes();
    constructUnits();
    if (searchCallback) searchCallback(nearestMarkers, !input ? true : false);
  }, [nearestMarkers]);

  useEffect(() => {
    if (!!input.length) {
      let labels = [];

      const timer = setTimeout(
        () =>
          get(
            `${endpoint}q=${input}&countrycodes=${getTwoLetterIsoArray(
              Countries
            )}&limit=5&format=jsonv2`
          )
            .then((result) => {
              result.map((location) => {
                labels.push({
                  value: {
                    lat: location.lat,
                    lng: location.lon,
                  },
                  label: location.display_name,
                });
              });
              setResults(labels);
            })
            .catch((e) => console.error(e)),
        400
      );

      return () => clearTimeout(timer);
    }
  }, [input]);

  const handleOverlay = () => {
    if (!isVisible) setIsVisible(true);
  };
  return (
    <div style={{zIndex: 2}}>
      {/* Search Line Start */}
      <FlexContainer
        padding="1rem"
        margin="0 auto"
        backgroundImage={`#${BackgroundColor}`}
        alignItems="center"
        smallAlignContent="center"
        justifyContent="center"
      >
        <H2
          color={textColor}
          lineHeight="1.38"
          fontWeight="700"
          size="28px"
          fontSizeSmall="18px"
          marginSmall="0 0 1rem 0"
          margin="0 30px 0 0"
        >
          {Heading}
        </H2>
        <RoundInputWrapper maxwidth="340px;">
          <Dropdown
            options={results}
            handleChange={handleChange}
            handleInput={(e) => handleInput(e)}
            SearchFieldText={SearchFieldText}
            NoHits={NoHits}
            Heading={Heading}
            handleOverlay={handleOverlay}
          />
        </RoundInputWrapper>
        {ShowUnitTypes && (
          <Paragraph
            color={textColor}
            lineHeight="1.38"
            fontSize="24px"
            fontSizeSmall="18px"
            marginSmall="1rem 0 1rem 0"
            margin="0 15px 0 15px"
          >
            {SearchTextUnit}
          </Paragraph>
        )}
        {ShowUnitTypes && (
          <RoundInputWrapper maxwidth="340px;">
            <Dropdown
              options={units}
              handleChange={handleUnitChange}
              handleInput={(e) => handleUnitInput(e)}
              SearchFieldText={SearchHintUnit}
              NoHits={NoHits}
              Heading={SearchTextUnit}
              handleOverlay={handleOverlay}
            />
          </RoundInputWrapper>
        )}
        {ShowPreschoolTypes && (
          <Paragraph
            color={textColor}
            lineHeight="1.38"
            fontSize="24px"
            fontSizeSmall="18px"
            marginSmall="1rem 0 1rem 0"
            margin="0 15px 0 15px"
          >
            {TypeHeading}
          </Paragraph>
        )}
        {ShowPreschoolTypes && (
          <RoundInputWrapper maxwidth="340px;">
            <MapBlockSelect
              multipleChoice={true}
              options={types}
              handleChange={handleTypeChange}
              handleInput={(e) => handleTypeInput(e)}
              SearchFieldText={TypeText}
              NoHits={NoHits}
              Heading={TypeText}
              handleOverlay={handleOverlay}
            />
          </RoundInputWrapper>
        )}
      </FlexContainer>
      {/* Search Line End */}
      <Leaflet
        height="450px"
        smallHeight="320px"
        zoom={4}
        width="100%"
        center={[55.505, 9.09]}
        nearestMarkers={nearestMarkers}
        selectedValue={selectedValue}
        markersData={mapMarkers}
        DirectionsLinkText={DirectionsLinkText}
        FindUnitText={FindUnitText}
        ActivateMapText={ActivateMapText}
        OverlayImage={OverlayImage}
        isVisible={isVisible}
        handleOverlay={handleOverlay}
        YouAreHereText={YouAreHereText}
      />
    </div>
  );
};
